// extracted by mini-css-extract-plugin
export var anchored = "TwoColumn-module--anchored--7263a";
export var left = "TwoColumn-module--left--20ba0";
export var reverse = "TwoColumn-module--reverse--733c1";
export var right = "TwoColumn-module--right--6b57d";
export var twoColumn = "TwoColumn-module--twoColumn--f1b44";